module.exports = __webpack_public_path__ + "static/media/Colors Of Autumn-01.5479c904.svg";